exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zoomIcon {\n  .zoom-n{fill:none}\n  .zoom-o{clip-path:url(#A)}\n  .zoom-p{clip-rule:evenodd}\n}", ""]);
